import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useAppDispatch } from '../../../../../app/hooks';
import { addCondition } from '../../../state';

export const AddConditionButton: React.FC = () => {
  const dispatch = useAppDispatch();

  return (
    <Button
      size="small"
      startIcon={<AddIcon />}
      onClick={() => dispatch(addCondition({ field: '', operator: '', value: '' }))}
      sx={{ textTransform: 'none' }}
    >
      Add Condition
    </Button>
  );
};

export default AddConditionButton;
